import { Map } from 'immutable';

const UPDATE_ONBOARDING_WIZARD_PROGRESS = 'UPDATE_ONBOARDING_WIZARD_PROGRESS';
const SET_VIRTUAL_MEMBER_ON_BOARDING = 'SET_VIRTUAL_MEMBER_ON_BOARDING';
const SET_RESIDENT_MEMBER_ON_BOARDING = 'SET_RESIDENT_MEMBER_ON_BOARDING';
export const VIRTUAL = 'VIRTUAL';
export const RESIDENT = 'RESIDENT';

const currentProgressOnboardingWizard=  (state={
  currentPage: 1,
  summary: new Map()
}, action) => {
  switch (action.type) {
    case UPDATE_ONBOARDING_WIZARD_PROGRESS:
      return {
        ...state,
        currentPage: action.payload.currentPage,
        summary: action.payload.summary
      };
    case SET_VIRTUAL_MEMBER_ON_BOARDING:
      return {
        ...state,
        type: VIRTUAL
      };
    case SET_RESIDENT_MEMBER_ON_BOARDING:
      return {
        ...state,
        type: RESIDENT
      };
    default:
      return state;
  }
};

export const setAsVirtualMemberOnBoarding = () => ({
  type: SET_VIRTUAL_MEMBER_ON_BOARDING
});

export  const setAsResidentMemberOnBoarding = () => ({
  type: SET_RESIDENT_MEMBER_ON_BOARDING
});

export default currentProgressOnboardingWizard;

export const getCurrentPage = (state) => state.currentProgressOnboardingWizard.currentPage;
export const getSummary = (state) => state.currentProgressOnboardingWizard.summary;
export const isVirtualOnboarding = (state) => state.currentProgressOnboardingWizard.type === VIRTUAL;
export const isResidentOnboarding = (state) => state.currentProgressOnboardingWizard.type === RESIDENT;
export const updateOnboardingWizardProgress = (currentPage, summary) => ({
  type: UPDATE_ONBOARDING_WIZARD_PROGRESS,
  payload: { currentPage, summary }
});



// WEBPACK FOOTER //
// ./src/reducers/currentProgressOnboardingWizard.js